import axios from 'axios';
import config from '@/config/env-constants';

function getProjectId() {
    if (config.currEnv === 'pallet-pooling') {
        return `${config.currEnv}`;
    } else {
        return `ayun-quantity-${config.currEnv}`;
    }
}

export default {
    baseUrl: `https://us-central1-${getProjectId()}.cloudfunctions.net`,

    saveAnalytics(param) {
        let url = `${this.baseUrl}/configureAnalytics`;
        return axios.post(url, param);
    },

    getDashboardAnalytics(param) {
        let url = `${this.baseUrl}/getDashboardAnalytics`;
        return axios.post(url, param);
    }
}